// One place in the reports -> one Google Maps URL.
//
// Every place we show comes from one of two sources, and they deep-link differently:
//   - Google Places: carries place_id, so we can open the exact listing. Reports
//     generated before place_id was stored have none, hence the fallback below.
//   - OpenStreetMap (part of the ecosystem layer): never has a place_id, so the
//     best we can do is search by name at its coordinates.
// The name+coordinate search is accurate in practice but can land on a map pin
// instead of a business page, which is why place_id is always preferred.
export function mapsUrl(place) {
  if (!place) return null;
  if (place.place_id) {
    return `https://www.google.com/maps/place/?q=place_id:${encodeURIComponent(place.place_id)}`;
  }
  const hasCoord = Number.isFinite(place.lat) && Number.isFinite(place.lng);
  const q = place.name && hasCoord ? `${place.name} ${place.lat},${place.lng}`
    : hasCoord ? `${place.lat},${place.lng}`
    : place.name || null;
  return q ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}` : null;
}
